import SiteLayout from "@/components/feature/SiteLayout";
import Seo from "@/components/feature/Seo";
import Hero from "@/pages/home/components/Hero";
import HotBoard from "@/pages/home/components/HotBoard";
import LatestFeed from "@/pages/home/components/LatestFeed";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import FaqSection from "@/pages/home/components/FaqSection";
import VoicesSection from "@/pages/home/components/VoicesSection";
import { topicList } from "@/mocks/topics";
import { categoryList } from "@/mocks/categories";
import { faqList } from "@/mocks/faq";
import { testimonialList } from "@/mocks/testimonials";
import type { Category, Faq, Testimonial, Topic } from "@/types/content";

export default function Home() {
  const topics: Topic[] = topicList;
  const categories: Category[] = categoryList;
  const faqs: Faq[] = faqList;
  const voices: Testimonial[] = testimonialList;

  const sorted = [...topics].sort((a, b) => a.rank - b.rank);
  const featured = sorted[0];
  const board = sorted.slice(0, 8);

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "瓜点 · 网络爆料雷达",
      url: "https://sunshinelabs.cn/",
      description:
        "聚合网络爆料今日热门事件、最新头条与全网热议榜单，快速掌握当前最受关注的爆料话题。",
      inLanguage: "zh-CN",
      potentialAction: {
        "@type": "SearchAction",
        target: "https://sunshinelabs.cn/rank?q={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "瓜点 · 网络爆料雷达",
      url: "https://sunshinelabs.cn/",
      email: "contact@guadian.example.com",
    },
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "今日热议榜单",
      itemListElement: board.map((t, i) => ({
        "@type": "ListItem",
        position: i + 1,
        url: `https://sunshinelabs.cn/topic/${t.id}`,
        name: t.title,
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  ];

  return (
    <SiteLayout>
      <Seo
        title="网络爆料 - 今日热门话题榜 | 瓜点爆料雷达"
        description="聚合网络爆料今日热门事件、最新头条与全网热议榜单，快速掌握当前最受关注的爆料话题，吃瓜追更一站看全，实时刷新热度排行。"
        keywords="网络爆料,网络爆料今日,网络爆料热门,网络爆料最新,网络爆料头条,网络爆料榜单,网络爆料热议"
        path="/"
        jsonLd={jsonLd}
      />
      <Hero featured={featured} />
      <HotBoard topics={board} />
      <LatestFeed topics={sorted} categories={categories} />
      <CategoryGrid categories={categories} />
      <FaqSection faqs={faqs} />
      <VoicesSection voices={voices} />
    </SiteLayout>
  );
}